import { css } from '@microsoft/fast-element';
import { agExternalStockStyles } from './external';
/**
 * The Grid Pro styles.
 * @public
 * @remarks this is the default CSS, bundles Alpine/Balham/Material AG themes.
 */
export const foundationGridProStyles = css `
  ${agExternalStockStyles}
  :host {
    width: 100%;
    height: 100%;
  }

  :host([ds-disconnected]) {
    opacity: 40%;
  }

  :host([ds-disconnected]) > * {
    cursor: not-allowed;
  }

  :host([ds-disconnected]) > * > * {
    pointer-events: none;
  }

  .ag-side-bar,
  .ag-menu {
    --ag-subheader-background-color: var(--ag-background-color);
    --ag-control-panel-background-color: var(--ag-background-color);
  }

  .ag-cell-inline-editing {
    height: inherit !important;
  }
`;
